import { useCallback } from 'react';
import { FieldArray, useFormikContext } from 'formik';

import Grid from '@mui/material/Grid';

import { graphql } from '@e-socna/data-layer';

import type { ThirdPartyForm_Person } from '../../fragments/person.fragment';

import { MembershipsDetails } from './MembershipsDetails';

export const ThirdPartyForm_PersonMembershipsDetailsStep_Person_Fragment =
  graphql(`
    fragment ThirdPartyForm_PersonMembershipsDetailsStep_Person_Fragment on Person {
      activeMemberships {
        _id
        organizationId
        functions
        contextualRoleIds
        representativeTypeIds
      }
    }
  `);

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
}

export const ThirdPartyPersonMembershipsDetailsFormStep = ({
  isInternal,
}: Readonly<Props>) => {
  const {
    values: { activeMemberships },
  } = useFormikContext<ThirdPartyForm_Person>();

  const fieldArrayRender = useCallback(
    () => (
      <MembershipsDetails
        activeMemberships={activeMemberships}
        isInternal={isInternal}
      />
    ),
    [activeMemberships, isInternal],
  );

  return (
    <Grid container sx={{ display: 'flex', flexGrow: 1 }}>
      <Grid size={12} sx={{ display: 'flex', flexDirection: 'column' }}>
        <FieldArray name="activeMemberships" render={fieldArrayRender} />
      </Grid>
    </Grid>
  );
};
